import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import {BeatLoader} from "react-spinners";
import { override } from '../helpers/utils.js';
import jwt_decode from "jwt-decode";
class OriginalBankRRN1 extends Component{
    constructor(props) {
        super(props);
        this.state ={
            OriginalBankRRNID:'',
            OriginalBankRRNList:[{value: '', label: 'Select'}],
            is_OriginalBankRRN_loading: true,
            OriginalBankRRNValue: [],
            OriginalBankRRNListOpen: false,
            OriginalBankRRNHeaderTitle: "Select [OriginalBankRRN]",
            object_code:[],
            OriginalBankRRNObject:[],
            search_object_code:[],
            OriginalBankRRN_name:""

        }
        this.closeOriginalBankRRNList = this.closeOriginalBankRRNList.bind(this);
    }

    componentDidUpdate() {
        const { OriginalBankRRNListOpen } = this.state;
        setTimeout(() => {
            if (OriginalBankRRNListOpen) {
                window.addEventListener('click', this.closeOriginalBankRRNList);
            } else {
                window.removeEventListener('click', this.closeOriginalBankRRNList);
            }
        }, 0);
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            userGroupName:decoded.userGroupName,
            object_code:decoded.object_code,
            object_type:decoded.object_type
        })
        this.getOriginalBankRRN(decoded.object_type,arrayCode,false,'',this.props.start_date,this.props.end_date);
    }
    restOriginalBankRRNFilter(){
        this.setState({
            OriginalBankRRNID: [],
        })
    }
    getOriginalBankRRN(object_type, object_code,is_search, search_value,start_date, end_date) {
        //alert(code); alert(type)
        if(is_search===false){
            this.setState({
                OriginalBankRRNID:[]
            })
        }
        this.setState({
//             search_code: code,
//             search_type: type,
            object_type: object_type,
            search_object_code: object_code
        })
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.OriginalBankRRNObject
        }
        this.setState({
            OriginalBankRRNList:[],
            is_OriginalBankRRN_loading: true
        })
        var url = '/filters/get-txn-summary-filters';

        axios.post(config.get('API_URL')+url, {
                user_type: object_type,
                object_code: object_code,
                filter_type: "Bank_RRN",
                is_search: is_search,
                search_value: search_value,
                start_date: start_date,
                end_date: end_date,
                is_current_date: this.props.is_current_date,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then((response) => {
                let OriginalBankRRNList = [];
                //this.setState({OriginalBankRRNID:''});
                console.log('Response**',response)
                response.data.map((OriginalBankRRN,index) => {
                    OriginalBankRRNList.push({value: OriginalBankRRN.bank_rrn, label: OriginalBankRRN.bank_rrn})
                });
                let res = []
                if (Array.isArray(this.state.OriginalBankRRNID) && this.state.OriginalBankRRNID) {
                    const uniq = new Set(OriginalBankRRNList.map(e => JSON.stringify(e)));

                    OriginalBankRRNList = Array.from(uniq).map(e => JSON.parse(e));

                }
                this.setState({
                    OriginalBankRRNList:OriginalBankRRNList,
                    is_OriginalBankRRN_loading: false
                })
            }).catch((e)=>{
                console.log(e)
                this.setState({
                    is_OriginalBankRRN_loading: false
                })
            })
    }
    changeOriginalBankRRN(login_type, OriginalBankRRN_object, checked_item, e) {
        if (login_type === 'OriginalBankRRN') {
            let value='';
            let sidArray = [];
            if(OriginalBankRRN_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                OriginalBankRRN_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            this.setState({
                OriginalBankRRNID: sidArray,
                OriginalBankRRNValue:OriginalBankRRN_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: true
            });
        } else {
            let item_list = this.state.OriginalBankRRNID;
            let item_list_object = this.state.OriginalBankRRNObject;
            let checked_list = OriginalBankRRN_object.value;
            let checked_list_object = OriginalBankRRN_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [OriginalBankRRN_object, ...this.state.OriginalBankRRNList.filter(item => item !== OriginalBankRRN_object)];
                this.setState({
                    OriginalBankRRNID: [...this.state.OriginalBankRRNID,OriginalBankRRN_object.value],
                    OriginalBankRRNObject: [...this.state.OriginalBankRRNObject,OriginalBankRRN_object],
                    isChange: true,
                    OriginalBankRRNList: newData,
                    OriginalBankRRN_name: OriginalBankRRN_object.label,

                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        OriginalBankRRNID: item_list,

                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        OriginalBankRRNObject: item_list_object,
                        isChange: true
                    })
                }
            }
            setTimeout(function() {
                this.props.onSelectOriginalBankRRN(this.state.OriginalBankRRNID);
            }.bind(this), 200);
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }

    }
    removeOriginalBankRRN(){
        const val = ''
        this.props.onSelectOriginalBankRRN(val);
        this.setState({
            OriginalBankRRNValue:[],
            OriginalBankRRNID:'',
            OriginalBankRRN_name:''
        });
    }
    OriginalBankRRNToggleList() {
        this.setState({
            OriginalBankRRNListOpen: !this.state.OriginalBankRRNListOpen,
        });
    }
    OriginalBankRRNFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getOriginalBankRRN(this.state.object_type, this.state.search_object_code,true, value,this.props.start_date,this.props.end_date);
        }.bind(this), 200);
    }
    closeOriginalBankRRNList() {
        this.setState({
            OriginalBankRRNListOpen: false,
        });
    }

    render() {
        //console.log(this.state.OriginalBankRRN_name);
        const OriginalBankRRN_lists = this.state.OriginalBankRRNList.map((OriginalBankRRN_object, index) => {
            // console.log("OriginalBankRRN_object");
            // console.log(OriginalBankRRN_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.OriginalBankRRNID.includes(OriginalBankRRN_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeOriginalBankRRN.bind(this, '', OriginalBankRRN_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{OriginalBankRRN_object.label}
                </li>
            )
        })

        return(

            <div className="dd-wrapper">
                <div className="dd-header" onClick={() => this.OriginalBankRRNToggleList()}>
                    {this.state.OriginalBankRRNID==''?
                        <div className="dd-header-title">{this.state.OriginalBankRRNHeaderTitle}</div>:
                        <div className="dd-header-title">{this.state.OriginalBankRRNID.length} Selected</div>
                    }


{/*                     {this.state.OriginalBankRRNListOpen===false? */}
                        <i className="fa fa-angle-down"></i>
{/*                     } */}
                </div>

                {this.state.OriginalBankRRNListOpen ===true?
                    <div
                        role="list"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <input
                            className="dd-list-search-bar"
                            placeholder="Search"
                            onChange={(e) => this.OriginalBankRRNFilterList(e)}
                        />
                        <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                        {/*<div className="dd-scroll-list">*/}
                        <ul className="dd-list">
                            {this.state.is_OriginalBankRRN_loading===true?
                                <li>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={5}
                                        color={'#666666'}
                                        loading={this.state.is_OriginalBankRRN_loading}
                                    />
                                </li>: null}
                            {OriginalBankRRN_lists}

                        </ul> </div>: null }
                {/*</div>*/}
            </div>

        );
    }
}

export default OriginalBankRRN1;